import { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import DropDownMenu from "./DropDownMenu";
import useIsMobile from "../../hooks/useIsMobile";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isSignedIn = useSelector((state) => state.user.isSignedIn);
  const currentUser = useSelector((state) => state.user.currentUser);
  const selectedCase = useSelector((state) => state.cases.selectedCase);
  const [menuOpen, setMenuOpen] = useState(false);
  const isMobile = useIsMobile();
  const menuRef = useRef(null);

  const canGoBack =
    isSignedIn &&
    location.pathname !== "/caselist" &&
    location.pathname !== "/home" &&
    location.pathname !== "/";

  const handleBack = () => {
    if (canGoBack) {
      navigate(-1);
    }
  };

  useEffect(() => {
    const handler = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    if (menuOpen) document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [menuOpen]);

  const goTo = (path) => {
    if (location.pathname !== path) {
      navigate(path);
    } else {
      navigate(path, { replace: true });
    }
  };

  const renderButtons = () =>
    isSignedIn ? (
      <button
        className={`flex items-center justify-center hover:text-[#30A69C] text-[#94A3B8] rounded-md text-sm font-medium cursor-pointer transition-colors duration-200 ${
          isMobile ? "h-10" : "h-10 px-3"
        }`}
        onClick={() => setMenuOpen((o) => !o)}
      >
        <AccountCircleIcon className="ml-2" style={{ color: "#30A69C" }} />
        <div className={`${isMobile ? "pr-2 w-24" : "px-3 py-2"}`}>
          {currentUser?.firstName} {currentUser?.lastName}
        </div>
      </button>
    ) : (
      <div className="flex items-center space-x-6">
        <button
          className="text-[#94A3B8] hover:text-[#E7EBEF] font-medium transition-colors duration-200 text-sm"
          onClick={() => goTo("/")}
        >
          Home
        </button>
        <button
          className="text-[#94A3B8] hover:text-[#E7EBEF] font-medium transition-colors duration-200 text-sm"
          onClick={() => goTo("/contact")}
        >
          Contact
        </button>
      </div>
    );

  return (
    <div
      className="relative"
      ref={menuRef}
      style={{ position: "fixed", top: 0, left: 0, right: 0, zIndex: 50 }}
    >
      <nav
        style={{
          backgroundColor: "#0D1117",
          borderBottom: "1px solid rgba(255,255,255,0.08)",
          width: "100%",
        }}
      >
        <div
          className={`flex items-center justify-between ${
            isSignedIn ? "h-14" : "h-20"
          } ${isMobile ? "px-4" : "px-8"}`}
        >
          <div className="flex items-center space-x-2">
            {canGoBack && (
              <button
                onClick={handleBack}
                className="text-[#94A3B8] mr-2 hover:bg-white/10 hover:text-[#E7EBEF] p-2 rounded-full transition-all duration-200"
                aria-label="Back"
              >
                <ArrowBackIcon />
              </button>
            )}
            <button
              onClick={() => goTo("/")}
              className={`flex items-center space-x-2 transition duration-300 ${
                isMobile ? "text-sm" : "text-base"
              }`}
            >
              {isSignedIn ? (
                <span className="flex flex-row items-center">
                  <span
                    className="whitespace-nowrap"
                    style={{
                      fontFamily: "'Instrument Serif', Georgia, serif",
                      fontWeight: 400,
                      fontSize: isMobile ? "20px" : "24px",
                      letterSpacing: "-0.01em",
                      color: "rgba(255, 255, 255, 1)",
                      WebkitFontSmoothing: "antialiased",
                      MozOsxFontSmoothing: "grayscale",
                    }}
                  >
                    Cardiowell
                  </span>
                  <span
                    className="text-sm portrait:text-xs font-normal ml-6 portrait:max-w-[120px] leading-tight break-words"
                    style={{ color: "#64748B" }}
                  >
                    {location.pathname.startsWith("/model") &&
                    selectedCase?.title
                      ? selectedCase.title
                      : ""}
                  </span>
                </span>
              ) : (
                <span
                  style={{
                    fontFamily: "'Instrument Serif', Georgia, serif",
                    fontWeight: 400,
                    fontSize: "28px",
                    letterSpacing: "-0.01em",
                    color: "rgba(255, 255, 255, 1)",
                    WebkitFontSmoothing: "antialiased",
                    MozOsxFontSmoothing: "grayscale",
                  }}
                >
                  Cardiowell
                </span>
              )}
            </button>
          </div>
          <div className="flex items-center space-x-4">{renderButtons()}</div>
        </div>
      </nav>
      <DropDownMenu isOpen={menuOpen} />
    </div>
  );
};

export default Navbar;
